<template>
  <v-container
    fluid
  >
    <v-layout
      text-center
      wrap
    >
      <v-flex v-if="fourohfour" > 
        <template>
          <v-data-table
            :headers="headers"
            :items="deals"
            :items-per-page="100"
            sort-by="calories"
            class="elevation-1"
            hide-default-footer
          >
            <template v-slot:header.logo="{ item }">
                <h2 class='headline'>Current Deals</h2> 
            </template>

            <template v-slot:item.name="{ item }">
               <div style="text-align: center;">
                 <a color="primary" dark outlined class="mb-2" v-on="on" @click="open(item)">{{ item.name }}</a>
               </div>
            </template>
            <template v-slot:item.status="{ item }">
               <div style="text-align: center;">
                {{ item.status }}
               </div>
            </template>            
            <template v-slot:item.available="{ item }">
               <div style="text-align: center;">
                {{ item.available }}
               </div>
            </template>
            <template v-slot:item.logo="{ item }">
              <div style="text-align: center;"><img v-bind:src="item.logo"  style="max-width: 150px;max-height: 70px; background-color: #add8e6; padding: 4px; border-radius: 5px;" ></div>
            </template>
            <template v-slot:top>
                <v-dialog v-model="dialog" max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ editedItem.name }}</span>
                      <v-spacer></v-spacer>
                      <img v-bind:src="editedItem.logo"  style="max-width: 150px;max-height: 70px; background-color: #add8e6; padding: 4px; border-radius: 5px;"/>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                            {{editedItem.description}}
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
            </template>
            <template v-slot:item.action="{ item }">
              <div style="text-align: center;">
              <v-btn color="primary" dark outlined class="mb-2" target="_blank" :href="`http://access.hedgecosecurities.com/?deal=${item.name}`">Deal Terms</v-btn>
              </div>
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" >Reset</v-btn>
            </template>
          </v-data-table>

        </template>
      </v-flex>
      <v-flex mb-12 v-else>
        <template>
          <div>For access please contact HedgeCo Securities</div>
          <h1>404 nothing found</h1>
        </template>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<style>
tbody tr {
     font-size: 10px !important;
     height: 80px;
     border-top: 10px;
     border-bottom: 10px;
     padding-top: 10px;
     padding-bottom: 10px;
}
tbody td {
     font-size: 12px !important;
}

table.v-table thead th { 
  font-size: 16px;
}
</style>

<script>

  import axios from 'axios'
  import VueCookies from 'vue-cookies'
  import Vue from 'vue'

  Vue.use(VueCookies)

  export default {
    data: () => ({
      fourohfour: true,
      dialog: false,
      headers: [
        { text: '', value: 'logo', sortable: false  },
        {
          text: 'Company Name',
          align: 'center',
          sortable: true,
          value: 'name',
        },
        { text: 'Deal Status', value: 'status', align: 'center', sortable: false },
/*        { text: 'Deal Close Date', value: 'close_date' },
        { text: 'Share Premium / Discount', value: 'premium_discount' },
        { text: 'Valuation', value: 'valuation' }, */
        { text: 'Available for Purchase',          align: 'center', value: 'available' },
        { text: '', value: 'action', sortable: false },
      ],
      deals: [],
      editedIndex: -1,
      editedItem: {
        id: '',
        name: '',
        description: '',
        status: '',
        close_date: '',
        premium_discount: '',
        valuation: '',
        available: ''},
      defaultItem: {
        id: '',
        name: '',
        description: '',
        status: '',
        close_date: '',
        premium_discount: '',
        valuation: '',
        available: ''
      },
    }),
    mounted () {
//      let 
      let urlParams = new URLSearchParams(window.location.search);
      let urlParam = urlParams.get('key')
      let cookieParam = this.$cookies.get('key')
      let finalParam = ''

      if (urlParam == null && cookieParam == null) {
        this.fourohfour = false
      } 

      if (cookieParam != null) {
          finalParam = cookieParam
      } 
      
      if (urlParam != null) {
        finalParam = urlParam
      } 

      // eslint-disable-next-line no-console
      console.log(finalParam)
      
      if (finalParam != 'e2a879ef-7925-46f7-a299-d0c233cbabe0') {
        this.fourohfour = false
      } else {
        this.$cookies.set('key', finalParam)
        // eslint-disable-next-line no-console
        if (urlParam != null) {
          window.location.href = "/"
        }
      }

      if (this.fourohfour){
        axios
          .get('https://r3cou0tkde.execute-api.us-east-1.amazonaws.com/prod')
          .then((response) => {
            this.deals = response.data
            // eslint-disable-next-line no-console
            console.log(response.data)

          })
      }
    },

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

//    created () {
//      this.initialize()
//    },

    methods: {
       open (item) {
        this.dialog = true
        this.editedItem = Object.assign({}, item)
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.deals[this.editedIndex], this.editedItem)
        } else {
          this.deals.push(this.editedItem)
        }
        this.close()
      },
    },
  }
</script>
